"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get JobsModule () {
        return JobsModule;
    },
    get JobsModuleMetadata () {
        return JobsModuleMetadata;
    }
});
const _common = require("@nestjs/common");
const _bull = require("@nestjs/bull");
const _nc_job_008_recover_disconnected_table_name = require("./migration-jobs/nc_job_008_recover_disconnected_table_name");
const _migratecontroller = require("~/modules/jobs/jobs/export-import/migrate.controller");
const _migrateservice = require("~/modules/jobs/jobs/export-import/migrate.service");
const _nocomodule = require("~/modules/noco.module");
const _redisHelpers = require("~/helpers/redisHelpers");
const _exportservice = require("~/modules/jobs/jobs/export-import/export.service");
const _importservice = require("~/modules/jobs/jobs/export-import/import.service");
const _atimportcontroller = require("~/modules/jobs/jobs/at-import/at-import.controller");
const _atimportprocessor = require("~/modules/jobs/jobs/at-import/at-import.processor");
const _duplicatecontroller = require("~/modules/jobs/jobs/export-import/duplicate.controller");
const _duplicateprocessor = require("~/modules/jobs/jobs/export-import/duplicate.processor");
const _duplicateservice = require("~/modules/jobs/jobs/export-import/duplicate.service");
const _metasynccontroller = require("~/modules/jobs/jobs/meta-sync/meta-sync.controller");
const _metasyncprocessor = require("~/modules/jobs/jobs/meta-sync/meta-sync.processor");
const _sourcecreatecontroller = require("~/modules/jobs/jobs/source-create/source-create.controller");
const _sourcecreateprocessor = require("~/modules/jobs/jobs/source-create/source-create.processor");
const _sourcedeletecontroller = require("~/modules/jobs/jobs/source-delete/source-delete.controller");
const _sourcedeleteprocessor = require("~/modules/jobs/jobs/source-delete/source-delete.processor");
const _webhookhandlerprocessor = require("~/modules/jobs/jobs/webhook-handler/webhook-handler.processor");
const _dataexportprocessor = require("~/modules/jobs/jobs/data-export/data-export.processor");
const _dataexportcontroller = require("~/modules/jobs/jobs/data-export/data-export.controller");
const _dataexportcleanupprocessor = require("~/modules/jobs/jobs/data-export-clean-up/data-export-clean-up.processor");
const _publicdataexportcontroller = require("~/modules/jobs/jobs/data-export/public-data-export.controller");
const _thumbnailgeneratorprocessor = require("~/modules/jobs/jobs/thumbnail-generator/thumbnail-generator.processor");
const _attachmentcleanup = require("~/modules/jobs/jobs/attachment-clean-up/attachment-clean-up");
const _useworkerprocessor = require("~/modules/jobs/jobs/use-worker/use-worker.processor");
const _attachmenturluploadprocessor = require("~/modules/jobs/jobs/attachment-url-upload/attachment-url-upload.processor");
const _jobsprocessor = require("~/modules/jobs/jobs.processor");
const _jobsmapservice = require("~/modules/jobs/jobs-map.service");
const _initmigrationjobs = require("~/modules/jobs/migration-jobs/init-migration-jobs");
const _nc_job_001_attachment = require("~/modules/jobs/migration-jobs/nc_job_001_attachment");
const _nc_job_002_thumbnail = require("~/modules/jobs/migration-jobs/nc_job_002_thumbnail");
const _nc_job_005_order_column = require("~/modules/jobs/migration-jobs/nc_job_005_order_column");
const _nc_job_007_recover_order_column = require("~/modules/jobs/migration-jobs/nc_job_007_recover_order_column");
const _nc_job_no_op = require("~/modules/jobs/migration-jobs/nc_job_no_op");
const _nc_job_009_audit_migration = require("~/modules/jobs/migration-jobs/nc_job_009_audit_migration");
const _jobslogservice = require("~/modules/jobs/jobs/jobs-log.service");
const _jobscontroller = require("~/modules/jobs/jobs.controller");
const _jobsservice = require("~/modules/jobs/redis/jobs.service");
const _jobseventservice = require("~/modules/jobs/jobs-event.service");
const _jobsservice1 = require("~/modules/jobs/fallback/jobs.service");
const _fallbackqueueservice = require("~/modules/jobs/fallback/fallback-queue.service");
const _Jobs = require("~/interface/Jobs");
const _nc_job_003_recover_links = require("~/modules/jobs/migration-jobs/nc_job_003_recover_links");
const _nc_job_004_cleanup_duplicate_column = require("~/modules/jobs/migration-jobs/nc_job_004_cleanup_duplicate_column");
const _globals = require("~/utils/globals");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
const JobsModuleMetadata = {
    imports: [
        (0, _common.forwardRef)(()=>_nocomodule.NocoModule),
        ...(0, _redisHelpers.getRedisURL)(_redisHelpers.NC_REDIS_TYPE.JOB) ? [
            _bull.BullModule.forRoot({
                url: (0, _redisHelpers.getRedisURL)(_redisHelpers.NC_REDIS_TYPE.JOB),
                prefix: _globals.CACHE_PREFIX === 'nc' ? undefined : `${_globals.CACHE_PREFIX}`
            }),
            _bull.BullModule.registerQueue({
                name: _Jobs.JOBS_QUEUE,
                defaultJobOptions: {
                    removeOnComplete: true,
                    attempts: 1
                }
            })
        ] : []
    ],
    controllers: [
        _jobscontroller.JobsController,
        ...process.env.NC_WORKER_CONTAINER !== 'true' ? [
            _duplicatecontroller.DuplicateController,
            _migratecontroller.MigrateController,
            _atimportcontroller.AtImportController,
            _metasynccontroller.MetaSyncController,
            _sourcecreatecontroller.SourceCreateController,
            _sourcedeletecontroller.SourceDeleteController,
            _dataexportcontroller.DataExportController,
            _publicdataexportcontroller.PublicDataExportController
        ] : []
    ],
    providers: [
        _jobsmapservice.JobsMap,
        _jobseventservice.JobsEventService,
        ...(0, _redisHelpers.getRedisURL)(_redisHelpers.NC_REDIS_TYPE.JOB) ? [] : [
            _fallbackqueueservice.QueueService
        ],
        {
            provide: 'JobsService',
            useClass: (0, _redisHelpers.getRedisURL)(_redisHelpers.NC_REDIS_TYPE.JOB) ? _jobsservice.JobsService : _jobsservice1.JobsService
        },
        _jobslogservice.JobsLogService,
        _jobsprocessor.JobsProcessor,
        _exportservice.ExportService,
        _importservice.ImportService,
        _duplicateprocessor.DuplicateProcessor,
        _duplicateservice.DuplicateService,
        _migrateservice.MigrateService,
        _atimportprocessor.AtImportProcessor,
        _metasyncprocessor.MetaSyncProcessor,
        _sourcecreateprocessor.SourceCreateProcessor,
        _sourcedeleteprocessor.SourceDeleteProcessor,
        _webhookhandlerprocessor.WebhookHandlerProcessor,
        _dataexportprocessor.DataExportProcessor,
        _dataexportcleanupprocessor.DataExportCleanUpProcessor,
        _thumbnailgeneratorprocessor.ThumbnailGeneratorProcessor,
        _attachmentcleanup.AttachmentCleanUpProcessor,
        _useworkerprocessor.UseWorkerProcessor,
        _attachmenturluploadprocessor.AttachmentUrlUploadProcessor,
        // Migration Jobs
        _initmigrationjobs.InitMigrationJobs,
        _nc_job_001_attachment.AttachmentMigration,
        _nc_job_002_thumbnail.ThumbnailMigration,
        _nc_job_003_recover_links.RecoverLinksMigration,
        _nc_job_004_cleanup_duplicate_column.CleanupDuplicateColumnMigration,
        _nc_job_005_order_column.OrderColumnMigration,
        _nc_job_no_op.NoOpMigration,
        _nc_job_007_recover_order_column.RecoverOrderColumnMigration,
        _nc_job_008_recover_disconnected_table_name.RecoverDisconnectedTableNames,
        _nc_job_009_audit_migration.AuditMigration
    ],
    exports: [
        'JobsService',
        _jobslogservice.JobsLogService,
        _duplicateprocessor.DuplicateProcessor
    ]
};
let JobsModule = class JobsModule {
};
JobsModule = _ts_decorate([
    (0, _common.Module)(JobsModuleMetadata)
], JobsModule);
